import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    let current = Math.floor(Math.random() * recentBuyers.length);
    const show = () => {
      current = (current + 1) % recentBuyers.length;
      setIndex(current);
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, VISIBLE_MS + GAP_MS);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto" aria-live="polite" data-id="element-239" data-mp="1fxvd1lc939rm">
      <AnimatePresence data-id="element-240" data-mp="n6v54zastluo">
        {visible && !dismissed && <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(10,26,54,0.4)] sm:w-[340px]" data-id="element-241" data-mp="n97mpbcn9u77">
            <img src={images.mainMockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-canvas object-contain" data-id="element-242" data-mp="23m67a5nfyb6x" />
            <div className="min-w-0" data-id="element-243" data-mp="2anrxhbfrdkkl">
              <p className="text-sm leading-snug text-navy" data-id="element-244" data-mp="2aqxk8k0x0ad5">
                <strong data-id="element-245" data-mp="2fmcvd47jfs5v">{buyer.name}</strong> from <strong data-id="element-246" data-mp="2fph8ir2zdy8o">{buyer.country}</strong> just purchased the BCM Diagnostic Blueprint™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-247" data-mp="2plu09jeyu20s">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-248" data-mp="2pjhltg8f29sh" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-canvas hover:text-navy" data-id="element-249" data-mp="1wxodkr4cq2yb">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-250" data-mp="1972hzzbjab57" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}